import { render } from "./App.vue?vue&type=template&id=4bd44a14"
const script = {}

import "./App.vue?vue&type=style&index=0&id=4bd44a14&lang=scss"

import exportComponent from "/home/stork/stork/pwa_test/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__